import { instanceReadStatistics } from 'client/redux/instance/actionCreators';
import { INSTANCE_FATD_READ_STATISTICS } from 'client/redux/fatd/constants';

export const instanceFatdReadStatistics = (id, statistic, query) => dispatch => {
  return dispatch(instanceReadStatistics(INSTANCE_FATD_READ_STATISTICS, id, statistic, query));
};
